<template>
  <div class="t-timer">
    <span>00</span><span>:</span><span>{{ secText }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sec: 60,
    };
  },
  computed: {
    secText() {
      return this.sec < 10 ? `0${this.sec}` : this.sec;
    },
  },
  methods: {
    startTimer() {
      if (this.sec > 0) {
        this.sec = this.sec - 1;
        setTimeout(() => this.startTimer(), 1000);
      } else this.$emit('onFinish');
    },
  },
  mounted() {
    this.startTimer();
  },
};
</script>

<style lang="sass">
.t-timer
    padding-left: 16px
    font-size: 16px
    border-bottom: 1px dashed transparent
</style>



// WEBPACK FOOTER //
// src/templates/components/ui/timer.vue